import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, forwardRef } from 'react';
import { Components as TypeaheadComponents } from './typeahead.style';
const TypeaheadInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      value,
      options,
      onChange,
      onSuggestionSelect,
      maxSuggestion,
      clearButton,
      enableNormalization = true
    } = props,
    // fit,
    rest = __rest(props, ["value", "options", "onChange", "onSuggestionSelect", "maxSuggestion", "clearButton", "enableNormalization"]);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);
  const [suggestion, setSuggestion] = useState(options);
  const getDefaultSelection = () => {
    const sugg = (options || []).filter(item => item.value === value);
    return sugg.length ? sugg[0] : null;
  };
  const [selectedSuggestion, setSelectedSuggestion] = useState(getDefaultSelection());
  const [inputText, setInputText] = useState('');
  useEffect(() => {
    const sugg = (options || []).filter(item => item.value === value);
    setInputText(sugg.length ? sugg[0].label : '');
    setSelectedSuggestion(sugg.length ? sugg[0] : null);
  }, [value]);
  useEffect(() => {
    let sugg = _toConsumableArray(options || []);
    sugg = sugg.filter(option => {
      var _a, _b;
      if (enableNormalization) {
        return ((_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().search(new RegExp(normalizeInput(inputText === null || inputText === void 0 ? void 0 : inputText.toLocaleLowerCase()), 'i'))) !== -1;
      } else {
        return (_b = option === null || option === void 0 ? void 0 : option.label) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase().includes(inputText === null || inputText === void 0 ? void 0 : inputText.toLocaleLowerCase());
      }
    });
    if (sugg.length && sugg[0].value !== (selectedSuggestion === null || selectedSuggestion === void 0 ? void 0 : selectedSuggestion.value)) {
      setSuggestion(sugg);
      setShowSuggestion(true);
    } else {
      setSuggestion(null);
    }
  }, [inputText, options, selectedSuggestion]);
  const onInputBlur = () => {
    if (!mouseEnter) {
      setShowSuggestion(false);
    }
  };
  const onInputChange = e => {
    setInputText(e.target.value);
    setShowSuggestion(true);
    if (selectedSuggestion && e.target.value !== selectedSuggestion.value) {
      setSelectedSuggestion(null);
    }
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };
  const onSuggestionClick = item => {
    setInputText(item.label);
    setSelectedSuggestion(item);
    setShowSuggestion(false);
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect(item);
    }
  };
  const onClear = () => {
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect(null);
    }
    setInputText('');
  };
  const normalizeInput = value => {
    return value.replace(',', '').replace(/\s/g, '');
  };
  const onMouseEnter = () => {
    setMouseEnter(true);
  };
  const onMouseLeave = () => {
    setMouseEnter(false);
  };
  return _jsxs(TypeaheadComponents.Wrapper, {
    children: [_jsx(TypeaheadComponents.InputElement, _extends({
      value: inputText,
      onChange: e => onInputChange(e),
      onBlur: onInputBlur,
      clearButton: clearButton,
      onClear: onClear,
      ref: ref,
      focus: showSuggestion
    }, rest)), showSuggestion && inputText.length > 0 && _jsx(TypeaheadComponents.OptionsContainer, _extends({
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, {
      children: _jsx(TypeaheadComponents.OptionsList, _extends({
        "$type": "input"
      }, {
        children: suggestion && suggestion.length ? suggestion.slice(0, maxSuggestion || suggestion.length).map(item => _jsx(TypeaheadComponents.OptionsListItem, _extends({
          onClick: () => onSuggestionClick(item)
        }, {
          children: item.label
        }), item.id)) : _jsx(TypeaheadComponents.OptionsListItem, {
          children: "No Options"
        })
      }))
    }))]
  });
});
export default TypeaheadInput;